import { createSlice } from "@reduxjs/toolkit";

const posProductsSlice = createSlice({
  name: "posProducts",
  initialState: [],
  reducers: {
    updateToPosProducts: (state, action) => {
      const { ItemC, updatedItem } = action.payload;
      const index = state.findIndex((item) => item.ItemC === ItemC);
      if (index !== -1) {
        state[index] = { ...state[index], ...updatedItem };
      }
    },
    resetItems: () => {
      return [];
    },
    setPosProducts: (state, action) => {
      return action.payload;
    },
  },
});

export const { updateToPosProducts, resetItems, setPosProducts } =
  posProductsSlice.actions;
export default posProductsSlice.reducer;
